export default "__VITE_ASSET__DHXbh9Rt__"